import { icons } from "assets";
import { RouteAwareCrumbs } from "Components/shared/breadcrumbs";
import { Tab, TabPanel, Tabs } from "Components/shared/tab";
import TableDisplay from "Components/shared/table";
import Text from "Components/shared/text";
import {
  EmptyComponent,
  Status,
  TransactionType,
} from "Components/shared/transactions";
import React, { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useGetUsersTransactions } from "services/transactionService";
import { currencyMap } from "utils/constants/maps";
import { capitalize, convertDate } from "utils/stringServices";
import styles from "./history.module.css";


const format = Intl.NumberFormat("en-US");
const dateFormat = Intl.DateTimeFormat("en-GB");
const convertServerDate = (str) => {
  if(!str || typeof str !== "string") return str
  return str.split(" ").join("T")
}
const tableStructure = {
  0: {
      field:"transactionType",
      renderItem:(rowData) => (
          <TransactionType type={rowData?.type === "deposit" ? "credit" : (rowData?.type === "withdraw" ? "debit": (rowData?.type === "swap" ? "swap" :""))} /> 
      ),
      cellStyle:{},
  },
  1:{
      renderItem: rowData => (
          <Text style={{fontWeight:"300"}}>{capitalize(rowData.type)}: <br /> {rowData.details || "Payment Id: 234565666766"}</Text>
      ),
      cellStyle:{
          minWidth: "220px",

      }
  },
  2:{
      renderItem: rowData => (
          <Text style={{fontWeight:"300"}}>Date:<br /> {convertDate(rowData.timestamp)}</Text>
      ),
      cellStyle:{
          minWidth: "110px"
      }  
  },
  3:{
      renderItem: rowData => (
          <Status variant={rowData.status == "ok" ? "completed":"pending"} />
      ),
      cellStyle:{
          textAlign:"left",

      }    
  },
  4:{
      renderItem: rowData => (
          <Text style={{display:"flex",
          alignItems: "center",
          justifySelf:"flex-end"}}>
          {`${currencyMap[rowData.currency?.toLowerCase?.()] || "$"}
          ${format.format(rowData.amount)}`}</Text>
      ),
      cellStyle:{
          display:"flex",
          alignItems: "center",
          justifyContent: "flex-end",
          justifySelf:"flex-end",
          minWidth:"120px",
          flexGrow:2,
          paddingRight:"24px"
      }  
  }
}

const NairaWallet = () => {

  const navigate = useNavigate();
  const [selectedTab, setSelectedTab] = useState(0);
  const {data: depositTransactions} = useGetUsersTransactions("deposit");
  const {data: withdrawTransactions} = useGetUsersTransactions("withdraw");
 
const allTransactions = useMemo(() => {
   const res = depositTransactions?.concat(withdrawTransactions);
   return res?.sort((a,b) => new Date(convertServerDate(a.timestamp)) - new Date(convertServerDate(b.timestamp)) );
}, [depositTransactions?.length, withdrawTransactions?.length])
  const handleChange = (e, tabIndex) => {
    setSelectedTab(tabIndex);
  };
  const NameMap = {
    "/transaction-history/naira-wallet": "Naira Wallet Transaction",
    "/transaction-history": "Transaction History",
  };
  return (
    <div className={styles.root}>
      <Text variant="lg" tag="h1" style={{ fontWeight: "700" }}>
        Naira Wallet Transaction
      </Text>
      <RouteAwareCrumbs nameMap={NameMap} />

      <div className={styles.contentContainer}>
        <Text
          variant="md2"
          tag="h2"
          style={{ fontWeight: "700", marginBottom: "24px" }}
        >
          Transactions
        </Text>
        <Tabs value={selectedTab} handleChange={handleChange} fullWidth>
          <Tab label="All" />
          <Tab label="Credit" />
          <Tab label="Debit" />
        </Tabs>
        <TabPanel value={selectedTab} index={0}>
          <TableDisplay data={allTransactions || []} column={tableStructure} />
        </TabPanel>
        <TabPanel value={selectedTab} index={1}>
        <TableDisplay
            data={ depositTransactions || []}
            column={tableStructure}
            emptyComponent={
              <div className={styles.emptyContainer}>
                <EmptyComponent
                  graphics={
                    <img
                      src={icons.empty_transaction}
                      alt="empty transactions"
                    />
                  }
                  title="Opps! You do not have any transaction history"
                  description="Looks like you do not have any transaction history. Send money to your wallet today to see your transaction history"
                  action={{
                    label: "Go to wallet",
                    onClick: (e) => {},
                    fullWidth: true,
                  }}
                />
              </div>
            }
          />
        </TabPanel>
        <TabPanel value={selectedTab} index={2}>
          <TableDisplay
            data={ withdrawTransactions || []}
            column={tableStructure}
            emptyComponent={
              <div className={styles.emptyContainer}>
                <EmptyComponent
                  graphics={
                    <img
                      src={icons.empty_transaction}
                      alt="empty transactions"
                    />
                  }
                  title="Opps! You do not have any transaction history"
                  description="Looks like you do not have any transaction history. Send money to your wallet today to see your transaction history"
                  action={{
                    label: "Go to wallet",
                    onClick: (e) => {},
                    fullWidth: true,
                  }}
                />
              </div>
            }
          />
        </TabPanel>
      </div>
    </div>
  );
};

export default NairaWallet;
